import { Volume2, MicIcon } from 'lucide-react';
import { IconCircleCheck } from '@tabler/icons-react';
import { translations } from '../../../translations/chatInputTranslations';

type AudioTestProps = {
  isAudioReady: boolean;
  audioLevel: number;
  languageCode?: string;
  isTextRightToLeft: boolean;
};

export function AudioTest({
  isAudioReady,
  audioLevel,
  languageCode = 'en',
  isTextRightToLeft = false,
}: AudioTestProps) {
  const t = translations[languageCode] || translations.en;
  return (
    <div
      className={`space-y-2 pt-4 border ${isAudioReady ? 'border-green-300' : 'border-gray-200'} rounded-lg p-4 ${isAudioReady ? 'bg-green-50' : 'bg-white'}`}
    >
      <div className="flex items-center justify-between relative">
        <h4 className="font-medium text-sm flex items-center gap-2">
          <MicIcon className="w-5 h-5" />
          {t.microphone}
        </h4>
        {isAudioReady && (
          <div className={`ml-auto absolute ${isTextRightToLeft ? 'left-0' : 'right-0'} -top-0.5`}>
            <IconCircleCheck className="w-6 h-6 text-white fill-green-600" />
          </div>
        )}
      </div>
      <div className="p-3 bg-gray-50 rounded-lg border border-gray-100">
        <div className="flex items-center gap-3 w-full ">
          <Volume2 className="w-4 h-4 text-gray-600 flex-shrink-0" />
          <div className="flex-1">
            <div className="w-full bg-gray-300 rounded-full h-2">
              <div
                className="bg-green-500 h-2 rounded-full transition-all duration-200 ease-in-out "
                style={{
                  width: `${isAudioReady ? Math.min(audioLevel * 2000, 100) : 0}%`,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
